import moment from "moment";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Avatar, Grid, TextField } from "@mui/material";
import { api_urls } from "../../../../utils/api-urls";
import * as ReligiousActions from '../../../../redux/actions/religiousAction';

const AddDailyDarshan = ({ mode }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const stateData = location?.state?.stateData;

  const [inputFieldDetail, setInputFieldDetail] = useState({ title: stateData ? stateData?.title : '', link: stateData ? stateData?.link : '', startDateTime: stateData ? moment(stateData?.startDateTime)?.format('YYYY-MM-DDTHH:mm') : '', endDateTime: stateData ? moment(stateData?.endDateTime)?.format('YYYY-MM-DDTHH:mm') : '', city: stateData ? stateData?.city : '', description: stateData ? stateData?.description : '' });
  const [inputFieldError, setInputFieldError] = useState({ title: '', link: '', startDateTime: '', endDateTime: '', city: '', description: '' });
  const [image, setImage] = useState({ file: stateData ? api_urls + stateData?.image : '', bytes: '' });
  console.log(stateData);

  //* Handle Input Field : Error
  const handleInputFieldError = (input, value) => setInputFieldError((prev) => ({ ...prev, [input]: value }));

  //* Handle Input Field : Data
  const handleInputField = (event) => setInputFieldDetail({ ...inputFieldDetail, [event?.target?.name]: event?.target?.value });

  //* Handle dailyDarshan Image
  const handleImage = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      if (e.target.files[0]?.size < 1 * 1024 * 1024) {
        setImage({
          file: URL.createObjectURL(e.target.files[0]),
          bytes: e.target.files[0],
        });
      } else {
        alert("Please upload image having size less than 1 MB")
      }
    }
    handleInputFieldError("image", null)
  };

  //! Handle Validation
  const handleValidation = () => {
    let isValid = true;
    const { title, link, city, startDateTime, endDateTime, description } = inputFieldDetail;
    const { file } = image;

    if (!title) {
      handleInputFieldError("title", "Please Enter Title");
      isValid = false;
    }
    if (!link) {
      handleInputFieldError("link", "Please Enter Link");
      isValid = false;
    }
    if (!city) {
      handleInputFieldError("city", "Please Enter City");
      isValid = false;
    }
    if (!startDateTime) {
      handleInputFieldError("startDateTime", "Please Enter Start Date and Time");
      isValid = false;
    }
    if (!endDateTime) {
      handleInputFieldError("endDateTime", "Please Enter End Date and Time");
      isValid = false;
    }
    if (!description) {
      handleInputFieldError("description", "Please Enter Description");
      isValid = false;
    }
    if (!file) {
      handleInputFieldError("image", "Please Select Image");
      isValid = false;
    }

    return isValid;
  };

  //! Handle Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("dailyDarshan Data :: ", { ...inputFieldDetail, image });
    const { title, link, city, description, endDateTime, startDateTime } = inputFieldDetail;

    if (handleValidation()) {
      if (stateData) {
        let formData = new FormData();
        formData.append("id", stateData?._id);
        formData.append("title", title);
        formData.append("link", link);
        formData.append("city", city);
        formData.append("description", description);
        formData.append("startDateTime", startDateTime);
        formData.append("endDateTime", endDateTime);
        formData.append("thumbnail", image?.bytes);

        const payload = {
          data: formData,
          onComplete: () => navigate('/religious/daily-darshan')
        }

        //! Dispatching API for Updating Daily Darshan
        dispatch(ReligiousActions?.updateDailyDarshan(payload));

      } else {
        let formData = new FormData();
        formData.append("title", title);
        formData.append("link", link);
        formData.append("city", city);
        formData.append("description", description);
        formData.append("startDateTime", startDateTime);
        formData.append("endDateTime", endDateTime);
        formData.append("thumbnail", image?.bytes);

        const payload = {
          data: formData,
          onComplete: () => navigate('/religious/daily-darshan')
        }

        //! Dispatching API for Creating Daily Darshan
        dispatch(ReligiousActions?.createDailyDarshan(payload));
      }
    } else {
      console.log("Validation Error");
    }
  };

  return (

    <>
      <div style={{ padding: "20px", backgroundColor: "#fff", marginBottom: "20px", boxShadow: '0px 0px 5px lightgrey', borderRadius: "10px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px", fontFamily: 'Philosopher', backgroundColor: "#fff" }}>
          <div style={{ fontSize: "20px", fontWeight: "600", color: "#667284" }}>{mode} Daily Darshan</div>
          <div onClick={() => navigate("/religious/daily-darshan")} style={{ fontWeight: "600", backgroundColor: "#164E62", color: "#fff", padding: "5px 10px", borderRadius: "5px", cursor: "pointer", fontSize: "14px" }}>Display</div>
        </div>

        <Grid container sx={{ alignItems: "center" }} spacing={3}>
          <Grid item lg={6} md={6} sm={12} xs={12} >
            <TextField
              label="Title" variant='outlined' fullWidth
              name='title'
              value={inputFieldDetail?.title}
              onChange={handleInputField}
              error={inputFieldError?.title ? true : false}
              helperText={inputFieldError?.title}
              onFocus={() => handleInputFieldError("title", null)}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <TextField
              label="Link" variant='outlined' fullWidth
              name='link'
              value={inputFieldDetail?.link}
              onChange={handleInputField}
              error={inputFieldError?.link ? true : false}
              helperText={inputFieldError?.link}
              onFocus={() => handleInputFieldError("link", null)}
            />
          </Grid>

          <Grid item lg={6} md={12} sm={12} xs={12}>
            <TextField
              label={<>Start Date-Time <span style={{ color: "red" }}>*</span></>} variant="outlined" fullWidth
              type="datetime-local"
              name='startDateTime'
              value={inputFieldDetail?.startDateTime}
              onChange={handleInputField}
              error={inputFieldError.startDateTime ? true : false}
              helperText={inputFieldError.startDateTime}
              onFocus={() => handleInputFieldError("startDateTime", null)}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item lg={6} md={12} sm={12} xs={12}>
            <TextField
              label={<>End Date-Time <span style={{ color: "red" }}>*</span></>} variant="outlined" fullWidth
              type="datetime-local"
              name='endDateTime'
              value={inputFieldDetail?.endDateTime}
              onChange={handleInputField}
              error={inputFieldError.endDateTime ? true : false}
              helperText={inputFieldError.endDateTime}
              onFocus={() => handleInputFieldError("endDateTime", null)}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item lg={6} md={12} sm={12} xs={12} >
            <TextField
              label="City" variant='outlined' fullWidth
              name='city'
              value={inputFieldDetail?.city}
              onChange={handleInputField}
              error={inputFieldError?.city ? true : false}
              helperText={inputFieldError?.city}
              onFocus={() => handleInputFieldError("city", null)}
            />
          </Grid>

          <Grid item lg={6} md={12} sm={12} xs={12} >
            <Grid container sx={{ alignItems: "center", flexWrap: "nowrap" }}>
              <Grid item xs={2} >
                <Avatar src={image.file} style={{ width: 40, height: 40 }} />
              </Grid>
              <Grid component="label" item xs={10} style={{ backgroundColor: "#E2E8F0", textAlign: "center", color: "#666666", padding: "10px 30px", borderRadius: "20px", cursor: "pointer", fontWeight: "500", fontSize: "14px" }}>
                Upload Image
                <input onChange={handleImage} hidden accept="image/*" type="file" />
              </Grid>
            </Grid>
            {inputFieldError?.image && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "10px 0 0 15px" }}>{inputFieldError?.image}</div>}
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12} >
            <TextField
              label="Description" variant='outlined' fullWidth
              name='description'
              value={inputFieldDetail?.description}
              onChange={handleInputField}
              error={inputFieldError?.description ? true : false}
              helperText={inputFieldError?.description}
              onFocus={() => handleInputFieldError("description", null)}
            />
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container sx={{ justifyContent: "space-between" }}>
              <div onClick={handleSubmit} style={{ fontWeight: "500", backgroundColor: "#164E62", color: "#fff", padding: "10px 20px", borderRadius: "5px", cursor: "pointer", fontSize: "15px" }}>Submit</div>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>

  );
};

export default AddDailyDarshan;